<script setup>
import { useDepartmentsStore } from '~/store/departments'
import { useActualitiesStore } from '~/store/actualities'
import { useStudentsStore } from '~/store/students'
import { useEmployeesStore } from '~/store/employees'
import { usePublicationsStore } from '~/store/publications'
import { useAppStore } from '~/store/main'

const props = defineProps({
  nav: {
    type: Boolean,
    default: false,
  },
})

const departmentsStore = useDepartmentsStore()
const actualitiesStore = useActualitiesStore()
const studentsStore = useStudentsStore()
const employeesStore = useEmployeesStore()
const publicationsStore = usePublicationsStore()
const appStore = useAppStore()

const { setItems: setDepartmentsItems } = departmentsStore
const { resetActualities } = actualitiesStore
const { setStudents } = studentsStore
const { setEmployees } = employeesStore
const { setPublications } = publicationsStore
const { setMenuConfig, setIsLoaderActive } = appStore

const { locale } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const language = ref('')

const updateLanguage = () => {
  if (locale.value === 'cs') {
    language.value = 'English language'
    if (props.nav) language.value = 'EN'
  } else if (locale.value === 'en') {
    language.value = 'Český jazyk'
    if (props.nav) language.value = 'CZ'
  }
}

const changeLocale = () => {
  const newLocale = locale.value === 'cs' ? 'en' : 'cs'

  window.location.replace(switchLocalePath(newLocale))

  setTimeout(() => {
    setIsLoaderActive(true)
    setMenuConfig([])
    setDepartmentsItems([])
    resetActualities()
    setStudents([])
    setEmployees([])
    setPublications([])
  }, 1500)
}

onMounted(() => {
  updateLanguage()
})

watch(locale, () => {
  updateLanguage()
})
</script>

<template>
  <button class="language" @click="changeLocale">
    {{ language }}
  </button>
</template>

<style lang="scss" scoped>
.language {
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  cursor: pointer;
  color: $color-6;

  &:focus-visible {
    outline: 2px dashed $color-root;
  }

  &:hover {
    color: $color-7;
  }
}
</style>
